import {
    CLEAR_ATTENDANCE_HISTORY,
    GET_ATTENDANCE_HISTORY,
    SET_ATTENDANCE_HISTORY_PAGINATION,
    SET_LOADING,
} from '../types'

const AttendanceReducer = (state, action) => {

    switch (action.type) {

        case GET_ATTENDANCE_HISTORY:
            return {
                ...state,
                attendanceHistory: action.payload,
                loading: false
            }

        case SET_ATTENDANCE_HISTORY_PAGINATION:
            return {
                ...state,
                attendanceHistoryPagination: action.payload,
                loading: false
            }

        case CLEAR_ATTENDANCE_HISTORY:
            return {
                ...state,
                attendanceHistory: [],
                loading: false
            }

        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state
    }

}

export default AttendanceReducer
